// extracted by mini-css-extract-plugin
export var dividerLine = "_8m-3";
export var itemImage = "_8m-9";
export var lightDivider = "_8m-4";
export var modalContent = "_8m-5";
export var modalContentCompact = "_8m-6";
export var productCard = "_8m-a";
export var productImage = "_8m-b";
export var productImageCompact = "_8m-7";
export var productImagePlaceholder = "_8m-c";
export var productImagePlaceholderCompact = "_8m-8";
export var progressBarBackground = "_8m-1";
export var progressBarContainer = "_8m-0";
export var progressBarFill = "_8m-2";